import Icon from '../components/Icon';

const Collapse = Icon(
  'collapse',
  <>
    <path
      fillRule="evenodd"
      d="M21.53 2.47a.75.75 0 0 1 0 1.06l-4.72 4.72h2.99a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75V4.2a.75.75 0 0 1 1.5 0v2.99l4.72-4.72a.75.75 0 0 1 1.06 0M4.2 15.75a.75.75 0 0 1 0-1.5H9a.75.75 0 0 1 .75.75v4.8a.75.75 0 0 1-1.5 0v-2.99l-4.72 4.72a.75.75 0 0 1-1.06-1.06l4.72-4.72z"
      clipRule="evenodd"
    />
  </>
);

export default Collapse;
